import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import type { Provider } from '@repo/api-gw-sdk';
import { KmsCopyablePolicy } from './kmsCopyablePolicy';
import { KmsEditKeyPolicyButton } from './kmsEditKeyPolicyButton';
export const KmsSuggestedPolicyContent = t0 => {
  const $ = _c(8);
  const {
    kmsKey,
    cloudProvider,
    withRestoreAccounts: t1
  } = t0;
  const withRestoreAccounts = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== cloudProvider || $[1] !== withRestoreAccounts) {
    t2 = <KmsCopyablePolicy cloudProvider={cloudProvider} withRestoreAccounts={withRestoreAccounts} />;
    $[0] = cloudProvider;
    $[1] = withRestoreAccounts;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== kmsKey) {
    t3 = <KmsEditKeyPolicyButton kmsKey={kmsKey} />;
    $[3] = kmsKey;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <Stack paddingX="40px" gap="24px" alignItems="flex-end">{t2}{t3}</Stack>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};